export const DEFAULT_CONFIG = {
  searchEnabled: false,
  animationEnabled: false,
  staticPlaceholder: 'Search for products',
  placeholderKeywords: ['Sarees', 'Jumpsuits', 'Heels'],
  keywordPrefix: 'Search',
};
